import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchAverageAdsPerPartnerProps = {
  startDate: Moment;
  endDate: Moment;
  report: string;
};
export type FetchAverageAdsPerPartner = (filters: FetchAverageAdsPerPartnerProps) => void;

const fetchAverageAdsPerPartner = ({
  startDate,
  endDate,
  report
}: FetchAverageAdsPerPartnerProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport(report, dispatch, params);
};

export default fetchAverageAdsPerPartner;
